import React from "react";
import ProfileImgDefault from "../../../images/profileImage.png";
import get from 'lodash/get';
export const CustomImagePreview = ({ className, emptyText, record, source, src, title, ...rest }) => {
  const sourceValue = get(record, source);
  if (Array.isArray(sourceValue)) {
    return "Not Supported";
  }
  console.log("sourceValue",sourceValue)
  return <img src={sourceValue ? sourceValue : ProfileImgDefault} className={className}
   style={{
     height: "100px",
     width: "100px",
     display:"block",
     margin:"auto",
     borderRadius: "50%",
     marginTop:"5px",
     marginLeft:"230px"
     }}
      alt="" />;
};
